import {AssociationType} from 'api/gen/AssociationType';
import {Bookmark} from 'api/gen/Bookmark';
import {TableId} from 'common/types/table-id';

/**
 * Resolves the table id for a mating list dialog.
 *
 * @param bookmark Tab bookmark that selects the workflow area.
 * @param associationType Association type used by the current workflow.
 * @returns The table id used by the shared table system, or `null`.
 */
export const getMatingTableId = (bookmark: Bookmark, associationType: AssociationType): TableId | null => {
    switch (bookmark) {
        case 'FEMALE':
            return 'matingCows';
        case 'MALE':
            return associationType === 'FLECKVIEH' ? 'matingFleckviehBulls' : 'matingHolsteinBulls';
        case 'COMPUTATION':
            return null;
    }
};
